import type {PullRequestCommitItem} from '../../../../page-data/payloads/timeline'

export function PullRequestCommitText({item}: {item: PullRequestCommitItem}) {
  return <>{`pushed ${item.additionalInfo.sha.slice(0, 7)}`} </>
}
